import React from 'react'
import Svg from './Svg'
export const SvgViewer = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M0 4.153l7.5-3v18l-7.5 3zm16.5 0v18l-7.5-2.5v-18zm7.5-3v18l-6 2.4v-18z" />
  </Svg>
))
SvgViewer.isIcon = true
export default SvgViewer
